<template>
	<div class="pl-5 pr-5 pb-5" style="height: 100%">
		<!-- <div class="pa-2" :style="'horizontalScroll'"> -->

		<alert-box v-model="alert.alerts" :type="alert.type"></alert-box>

		<v-expansion-panels v-if="filterOpen">
			<v-expansion-panel :value="true">
				<v-expansion-panel-header>Filters</v-expansion-panel-header>
				<v-expansion-panel-content>
					<div class="row">
						<v-select
							style="max-width: 300px"
							v-if="environmentSelect && environmentSelect.jobStatus"
							class="col-3 mt-4"
							item-text="status"
							multiple
							:items="environmentSelect.jobStatus"
							v-model="statusSelect"
							return-object
							@change="changeStatus"
							label="Status"
						></v-select>
						<auto-complete-entity
							style="max-width: 300px"
							class="col-4"
							ref="accountFilterRef"
							v-model="filter.accountId"
							entityApi="account"
							itemText="name"
							itemValue="id"
							fieldApi="name"
							:label="$tc('entities.account.title', 1)"
							prependIcon="mdi-find-replace"
							@keyup.enter.native="getJobs"
						/>
						<auto-complete-entity
							style="max-width: 300px"
							class="col-4"
							ref="itemFilterRef"
							v-model="filter.itemId"
							entityApi="item"
							itemText="description"
							itemValue="id"
							fieldApi="description"
							:label="$tc('entities.item.title', 1)"
							prependIcon="mdi-find-replace"
							@keyup.enter.native="getJobs"
						/>
						<auto-complete-entity
							style="max-width: 300px"
							class="col-4"
							ref="resourceFilterRef"
							v-model="filter.resourceId"
							entityApi="resource"
							itemText="description"
							itemValue="id"
							fieldApi="description"
							:label="$tc('entities.resource.title', 1)"
							prependIcon="mdi-find-replace"
							@keyup.enter.native="getJobs"
						/>
						<v-text-field
							style="max-width: 300px"
							prepend-icon="mdi-find"
							class="mt-4"
							label="Pesquisa"
							v-model="filter.search"
							clearable
							@keyup.enter.native="getJobs"
						></v-text-field>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>

		<v-btn
			v-if="environmentSelect"
			icon
			dark
			color="primary"
			class="mt-4 ml-5 mb-2"
			@click="
				pagination.page = 1;
				getJobs(true);
			"
			:loading="loading"
		>
			<v-icon>mdi-refresh</v-icon>
		</v-btn>

		<v-btn
			icon
			dark
			color="primary"
			class="mt-4 ml-5 mb-2"
			@click="filterOpen = !filterOpen"
			:loading="loading"
		>
			<v-icon>mdi-filter</v-icon>
		</v-btn>

		<v-progress-linear v-if="loading" indeterminate></v-progress-linear>

		<vue-scroll :ops="ops">
			<kanban-board
				class="kanbanbody"
				ref="kanban"
				:stages="jobStatusComp"
				:blocks="items"
				@update-block="updateBlock"
				@job-click="
					itemSelected = { id: null };
					itemSelected = { id: $event };
				"
			>
				<template slot="header" slot-scope="context">
					<v-toolbar :color="context.stage.bgColor" dark flat>
						<v-card-title class="subtitle-">{{
							context.stage.status
						}}</v-card-title>
						<v-spacer />
						<v-btn
							v-show="loadingTotals"
							loading
							color="white"
							icon
							absolute
							top
							right
							small
							text
						>
							<v-icon>mdi-loading</v-icon>
						</v-btn>
						<v-tooltip
							bottom
							v-if="
								!loadingTotals &&
									getTotalByStatus(context.stage.status).prodTotalEst
							"
						>
							<template v-slot:activator="{ on, attrs }">
								<!-- <v-btn color="primary" dark v-bind="attrs" v-on="on"> Button </v-btn> -->
								<div v-on="on" v-bind="attrs">
									<v-icon style="font-size: 20px" class="mr-1"
										>mdi-progress-check</v-icon
									>

									<span class="text-end" style="font-size: 11px">{{
										getTotalByStatusToString(context.stage.status)
									}}</span>

									<div
										v-if="totalFilterValidation()"
										class="text-end right"
										style="font-size: 11px"
									>
										({{ getTotalByStatusToString(context.stage.status, true) }})
									</div>
								</div>
							</template>
							<span>Est / Real</span>
						</v-tooltip>
					</v-toolbar>
				</template>

				<template slot="block-item" slot-scope="context">
					<job-group-card-block-kanban
						:block="context.block"
						:stage="context.stage"
						:stages="context.stages"
						@update-block="updateBlockManual($event.blockId, $event.nextStatus)"
						@job-click="
							itemSelected = { id: null };
							itemSelected = { id: $event };
						"
					>
					</job-group-card-block-kanban>
				</template>
			</kanban-board>
		</vue-scroll>

		<v-card-text v-if="loading" class="ma-5" style="position: relative">
			<v-fab-transition>
				<v-btn
					v-show="loading"
					:loading="loading"
					color="primary"
					icon
					absolute
					top
					right
				>
					<v-icon>mdi-loading</v-icon>
				</v-btn>
			</v-fab-transition>
		</v-card-text>
		<job-form-dialog
			@cancel="itemSelected.id = null"
			:jobId="itemSelected.id"
			@job-updated="jobUpdated"
		></job-form-dialog>
	</div>
</template>

<script>
	import jobService from "@/services/jobService";
	import jobGroupCardBlockKanban from "@/components/kanban/jobGroupCardBlockKanban";
	import jobFormDialog from "../components/forms/jobs/jobFormDialog";

	export default {
		components: {
			jobGroupCardBlockKanban,
			jobFormDialog,
		},
		data() {
			return {
				filterOpen: false,
				items: [],
				alert: { alerts: [], type: "error" },
				loading: false,
				filter: {
					accountId: null,
					resourceId: null,
					itemId: null,
					searchFields: null, //"code,status",
					search: null,
				},
				loadingTotals: false,
				totals: [],
				totalsFilter: [],
				statusSelect: [],
				pagination: { page: 1, limit: 15 },
				scrolledToBottom: false,
				environments: [],
				environmentSelect: null,
				environmentId: null,
				jobBlocks: [],
				jobs: [],
				sheet: false,
				itemSelected: {},
				ops: {
					bar: {
						background: "#000000",
						//keepShow: false,
						//size: '10px',
						//minSize: 0.2
					},
					vuescroll: {
						wheelScrollDuration: 0,
						wheelDirectionReverse: true,
					},
				},
			};
		},

		computed: {
			jobsComp() {
				if (!this.jobs || this.jobs == {} || this.jobs.length == 0) return [];

				let jobs = [];
				this.jobs.forEach((j) =>
					jobs.push({
						id: j.seq,
						status: j.status,
						code: j.code,
						description: j.description,
						entityId: j.id,
						obj: j,
					})
				);

				return jobs;
			},
			jobStatusComp() {
				if (!this.environmentSelect || this.environmentSelect == {}) return [];
				if (!this.environmentSelect.jobStatus) return [];
				let jobStatus =
					this.statusSelect.length > 0
						? this.statusSelect
						: this.environmentSelect.jobStatus;

				if (jobStatus && jobStatus.length == 0) return [];
				jobStatus.sort((a, b) => {
					return a.seq > b.seq ? 1 : a.seq < b.seq ? -1 : 0;
				});

				let stages = [];

				for (let i = 0; i < jobStatus.length; i++) {
					const js = jobStatus[i];
					stages.push({
						status: js.status,
						bgColor: js.color,
						id: i,
						entityId: js.id,
						obj: js,
					});
				}
				return stages;
			},
		},
		watch: {
			async scrolledToBottom(value) {
				if (value == false) return;
				this.pagination.page++;

				await this.getItems();
			},
			// async "pagination.page"() {
			//   await this.getItems();
			// },
			async environmentSelect() {
				//this.jobBlocks = [];
				//this.jobs = [];
				this.pagination.page = 1;
				this.items = [];
				await this.getItems();
				this.$forceUpdate();
			},
			job() {
				this.jobBlocks = this.getItemBlocks();
				this.$forceUpdate();
			},
		},
		methods: {
			setAutoPagination() {
				window.onscroll = async () => {
					let bottomOfWindow =
						document.documentElement.scrollTop + window.innerHeight ===
						document.documentElement.offsetHeight;
					if (bottomOfWindow) {
						this.pagination.page++;
						await this.getItems();
					}
				};
			},
			async more() {
				this.pagination.page++;
				await this.getItems();
			},
			totalFilterValidation() {
				return (
					this.filter.accountId ||
					this.filter.resourceId ||
					this.filter.itemId ||
					this.filter.search
				);
			},
			getTotalByStatusToString(status, filter) {
				let totals = filter
					? this.getTotalFilterByStatus(status)
					: this.getTotalByStatus(status);
				if (!totals) return "";
				return filter
					? `${Math.floor(totals.prodTotalEst)} / ${Math.floor(
							totals.prodTotalReal
					  )}`
					: `${parseFloat(totals.prodTotalEst).toFixed(1)} / ${parseFloat(
							totals.prodTotalReal
					  ).toFixed(1)}`;
			},
			changeStatus() {},
			async jobUpdated() {
				this.itemSelected.id = null;
				await this.getItems(true);
				//location.reload();
			},
			getItemBlocks() {
				if (!this.environmentSelect || !this.items || this.items.length == 0)
					return [];
				let jobs = [];
				this.$forceUpdate();
				return jobs;
			},
			async updateBlockManual(jobId, nextStatus) {
				let res = await this.updateBlock(
					{
						blockId: jobId,
						nextBlockStage: nextStatus,
					},
					null,
					true
				);
				if (res) await this.getItems(true);
			},
			async updateBlock(movingBlock, obj, last) {
				this.loading = true;
				const job = JSON.parse(movingBlock.blockId);
				const previousJob = movingBlock.previousBlockId
					? JSON.parse(movingBlock.previousBlockId)
					: null;
				let res = await jobService.updateStatus(
					job.id,
					previousJob ? previousJob.id : null,
					movingBlock.nextBlockStage,
					last
				);

				this.loading = false;
				if (!res.success) {
					this.alert.alerts = res.data;
					await this.getJobs();
				}
				return res.success;
			},

			getNextAndPreviousIndexStatus(index, count) {
				let previous = index - 1 < 0 ? null : index - 1;
				let next = index < count ? index + 1 : null;
				return { previous, next };
			},
			getJobStatusColor(status) {
				let item = this.environments.jobStatus.find(
					(js) => js.status == status
				)[0];
				if (!item) return "";
				return item.color;
			},
			async getEnvironments() {
				let res = await this.$http.get("user/environments");
				if (res.success) {
					this.environments = res.data;
					if (this.environments.length == 1)
						this.environmentSelect = this.environments[0];
				} else {
					this.alert.alerts = res.data;
				}
			},
			async getTotals() {
				this.loadingTotals = true;
				let res = await jobService.getTotalsKanban(this.environmentSelect.id);
				this.loadingTotals = false;
				if (res.success) this.totals = res.data;

				await this.getTotalsFilter();
			},
			async getTotalsFilter() {
				let res = await jobService.getTotalsKanban(
					this.environmentSelect.id,
					this.filter.accountId,
					this.filter.resourceId,
					this.filter.itemId,
					this.filter.searchFields,
					this.filter.search
				);
				if (res.success) this.totalsFilter = res.data;
			},
			getTotalByStatus(status) {
				if (!this.totals && this.totals.length > 0) return "";
				let total = this.totals.filter((t) => t.status == status)[0];
				if (!total) return "";
				return total;
			},

			getTotalFilterByStatus(status) {
				if (!this.totalsFilter && this.totalsFilter.length > 0) return "";
				let total = this.totalsFilter.filter((t) => t.status == status)[0];
				if (!total) return "";
				return total;
			},

			async getItems(clear) {
				if (clear) {
					this.items = [];
					this.pagination.page = 1;
				}

				this.loading = true;
				let res = await jobService.getKanbanByGroup(
					this.environmentSelect.id,
					this.filter.accountId,
					this.filter.resourceId,
					this.filter.itemId,
					this.filter.searchFields,
					this.filter.search,
					this.pagination.page,
					this.pagination.limit
				); //await this.$http.get("job");
				if (res.success) {
					this.getTotals();
					if (this.totalFilterValidation()) await this.getTotalsFilter();
					else this.totalsFilter = [];

					if (res.data.data.length == 0 && this.pagination.page > 1)
						this.pagination.page--;

					const dataResponse = res.data.data
						.map((group) => {
							return {
								...group,
								status: group.jobStatus,
								entityId: JSON.stringify(group),
								jobId: group.id,
								id: group.jobs[0].seq,
							};
						})
						.sort((a, b) => {
							return a.id > b.id ? 1 : 0;
						});

					dataResponse.forEach((group) => {
						group.jobs.forEach((job) => {
							this.setQtEstAndReal(job);
						});
					});

					let items = [...this.items, ...dataResponse];

					this.items = items;
					//this.$forceUpdate();
				} else {
					this.jobs.alerts = res.data;
				}

				this.loading = false;
				this.$forceUpdate();
			},
			updateKanban() {
				this.$refs.kanban.updatedBlocks();
				this.$refs.kanban.$mount();
				this.$forceUpdate();
			},
			setQtEstAndReal(job) {
				let qtReal = 0;
				let qtEstimated = 0;
				let obj = job;
				let jobStages = obj.jobStages;

				if (!jobStages || jobStages.length == 0) return { qtReal, qtEstimated };

				jobStages.sort((a, b) => {
					if (a.seq > b.seq) return 1;
					else if (a.seq < b.seq) return -1;
					else return 0;
				});
				let lastJobStage = jobStages[0];
				if (!lastJobStage.jobStageItemProds) return { qtReal, qtEstimated };
				let jsp = lastJobStage.jobStageItemProds.filter(
					(i) => i.itemId == obj.itemId
				);

				jsp.forEach((i) => {
					qtReal += i.qtReal;
					qtEstimated += i.qtEstimated;
				});

				job.qtEstAndReal = { qtReal, qtEstimated };
			},
		},
		async mounted() {
			this.setAutoPagination();
			await this.getEnvironments();
			this.environmentSelect = this.environments.find(
				(e) => e.id == this.$route.query.environmentId
			);
		},
	};
</script>

<style scoped>
	.kanbanbody {
		float: left;
		width: 4000px;
	}

	.horizontalScroll {
		width: 100vh;
		height: 100vw;
		overflow-y: auto;
		overflow-x: hidden;
		background: #2e2e2e;
		padding: 30px;
		-webkit-transform-origin: right top;
		transform-origin: right top;
		-webkit-transform: rotate(-90deg) translate3d(0, -100vh, 0);
		transform: rotate(-90deg) translate3d(0, -100vh, 0);
	}
	.horizontalScroll > * {
		-webkit-transform-origin: left top;
		transform-origin: left top;
		-webkit-transform: rotate(90deg) translate3d(0, calc(-100vh + 60px), 0);
		transform: rotate(90deg) translate3d(0, calc(-100vh + 60px), 0);
	}

	.item {
		width: calc(100vh - 60px);
		height: calc(100vh - 60px);
		background: #fdfffc;
		position: relative;
	}
	.item:not(:first-child) {
		margin-top: 30px;
	}
</style>
